import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BounceLoader } from "react-spinners";
import PageTitle from "../../../components/partials/PageTitle";
import {
  activateUser,
  deactivateUser,
  fetchSingleUser,
  resetUsers,
  unlockUser,
} from "../../../redux/slice/user/userSlice";

const UserProfile = () => {
  const [staffDetail, setStaffDetail] = useState({
    first_name: "",
    last_name: "",
    email: "",
    staff_id: "",
    office_name: "",
    roles: "",
    status: "",
  });
  const [userRoles, setUserRoles] = useState([]);
  const [hasEditUser, setHasEditUser] = useState();
  const [hasUnlockUser, setHasUnlockUser] = useState();
  const [hasActivateUser, setHasActivateUser] = useState();
  const [hasDeactivateUser, setHasDeactivateUser] = useState();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  // const { roles } = useSelector((state) => state.staff);
  const {
    isSuccess: fetchUserSuccess,
    user_info,
    isLoading,
    isActivating,
    isUnlocking,
  } = useSelector((state) => state?.user);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const breadcrumb = {
    from: {
      title: "User",
      link: "/admin/all-users",
    },
    current: {
      title: "User Profile",
      link: null,
    },
  };

  const handleDeactivate = (userId) => {
    dispatch(deactivateUser(userId));
  };

  const handleActivate = (userId) => {
    dispatch(activateUser(userId));
  };

  useEffect(() => {
    if (!isActivating && !isUnlocking) {
      dispatch(fetchSingleUser(id));
    }
  }, [dispatch, id, isActivating, isUnlocking]);

  useEffect(() => {
    if (fetchUserSuccess) {
      dispatch(resetUsers());
      return;
    }
  }, [dispatch, fetchUserSuccess]);

  useEffect(() => {
    if (fetchUserSuccess) {
      setStaffDetail({
        first_name: user_info?.[0]?.first_name,
        last_name: user_info?.[0]?.last_name,
        staff_id: user_info?.[0]?.staff_id,
        email: user_info?.[0]?.email,
        office_name: user_info?.[0]?.office_user?.office_name,
        status: user_info?.[0]?.status,
      });
      setUserRoles(user_info?.[0]?.roles);
    }
  }, [
    fetchUserSuccess,
    user_info,
    user_info.data,
    user_info.first_name,
    user_info.staff_id,
  ]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "user module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "view user details"
      )
    ) {
      navigate("/admin/dashboard");
    }
    setHasEditUser(
      user_permissions?.some((permission) => permission.name === "edit user")
    );
    setHasUnlockUser(
      user_permissions?.some((permission) => permission.name === "unlock user")
    );
    setHasActivateUser(
      user_permissions?.some(
        (permission) => permission.name === "activate user"
      )
    );
    setHasDeactivateUser(
      user_permissions?.some(
        (permission) => permission.name === "deactivate user"
      )
    );
  }, [navigate, user_permissions]);

  if (isLoading) {
    return (
      <div className='d-flex mt-lg-5 justify-content-center align-content-center'>
        <BounceLoader color='#2E3192' size={"70px"} />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Available Users' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary '>
                    User Details
                  </h4>
                  <span
                    onClick={() => navigate(-1)}
                    className='btn btn-primary btn-sm float-end '
                  >
                    Go Back
                  </span>
                </div>
              </div>
              {hasUnlockUser && (
                <div>
                  {user_info?.[0]?.locked === 1 && (
                    <div
                      class='alert alert-danger d-flex align-items-center justify-content-between'
                      role='alert'
                    >
                      <h5>User Account is Locked.</h5>
                      <button
                        className='btn btn-sm btn-success px-4'
                        onClick={() => dispatch(unlockUser(id))}
                      >
                        Unlock
                      </button>
                    </div>
                  )}
                </div>
              )}
              <div className='row'>
                <div className='col-md-9'>
                  {/* Staff Id */}
                  <div className='row mb-2'>
                    <div className='col-sm-2 col-md-3 text-right sm-text-end'>
                      <label for='staff_id' className='col-form-label'>
                        Staff Id
                      </label>
                    </div>
                    <div class='col-sm-6'>
                      <p className='form-control border-0 shadow'>
                        {staffDetail?.staff_id}
                      </p>
                    </div>
                  </div>
                  {/* First Name */}
                  <div className='row mb-2'>
                    <div className='col-sm-2 col-md-3 text-right sm-text-end'>
                      <label for='first_name' className='col-form-label'>
                        First Name
                      </label>
                    </div>
                    <div class='col-sm-6'>
                      <p className='form-control border-0 shadow'>
                        {staffDetail?.first_name}
                      </p>
                    </div>
                  </div>
                  {/* Last Name */}
                  <div className='row mb-2'>
                    <div className='col-sm-2 col-md-3 text-right sm-text-end'>
                      <label for='last_name' className='col-form-label'>
                        Last Name
                      </label>
                    </div>
                    <div className='col-sm-6'>
                      <p className='form-control border-0 shadow'>
                        {staffDetail?.last_name}
                      </p>
                    </div>
                  </div>
                  {/* Last Name */}
                  <div className='row mb-2'>
                    <div className='col-sm-2 col-md-3 text-right sm-text-end'>
                      <label for='email' className='col-form-label '>
                        Email
                      </label>
                    </div>
                    <div className='col-sm-6'>
                      <p className='form-control border-0 shadow'>
                        {staffDetail?.email}
                      </p>
                    </div>
                  </div>
                  {/* Office */}
                  <div className='row mb-2'>
                    <div className='col-sm-2 col-md-3 text-end sm-text-end'>
                      <label htmlFor='office' className={`form-label mt-1`}>
                        Office
                      </label>
                    </div>
                    <div className='col-sm-6'>
                      <p className='form-control border-0 shadow'>
                        {staffDetail?.office_name}
                      </p>
                    </div>
                  </div>
                  {/* Office */}
                  <div className='row mb-3'>
                    <div className='col-sm-2 col-md-3 text-end sm-text-end'>
                      <label htmlFor='office' className={`form-label mt-1`}>
                        Roles
                      </label>
                    </div>
                    <div className='col-sm-6'>
                      <p className='form-control border-0 shadow d-flex gap-2'>
                        {userRoles?.map((role, index) => (
                          <span className='fw-bold' key={index}>
                            "{role.name}"
                          </span>
                        ))}
                      </p>
                    </div>
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-sm-1'></div>
                  <div className='col-sm-3 d-flex gap-3'>
                    {hasEditUser && (
                      <Link
                        type='button'
                        className={`btn btn-warning btn-md px-4 rounded text-white`}
                        to={`/admin/user/edit-user/${id}`}
                        state={user_info}
                      >
                        Edit
                      </Link>
                    )}
                    {staffDetail?.status === 1
                      ? hasDeactivateUser && (
                          <button
                            type='button'
                            className={`btn btn-${
                              staffDetail?.status === 1 ? `danger` : "success"
                            } text-white btn-md px-4 rounded`}
                            onClick={
                              staffDetail?.status === 1
                                ? () => handleDeactivate(id)
                                : () => handleActivate(id)
                            }
                            disabled={isActivating}
                          >
                            {staffDetail?.status === 1
                              ? "Deactivate"
                              : "Activate"}
                          </button>
                        )
                      : hasActivateUser &&
                        hasDeactivateUser && (
                          <button
                            type='button'
                            className={`btn btn-${
                              staffDetail?.status === 1 ? `danger` : "success"
                            } text-white btn-md px-4 rounded`}
                            onClick={
                              staffDetail?.status === 1
                                ? () => handleDeactivate(id)
                                : () => handleActivate(id)
                            }
                            disabled={isActivating}
                          >
                            {staffDetail?.status === 1
                              ? "Deactivate"
                              : "Activate"}
                          </button>
                        )}
                        {hasEditUser && (
                          <Link
                            type='button'
                            className={`btn btn-info btn-md px-4 rounded text-white text-nowrap`}
                            to={{ pathname: `/admin/user/user-profile/${id}/customers`,}}
                            state={{id: staffDetail?.staff_id, office_id: user_info?.[0]?.office_id}}
                          >
                            View Customers
                          </Link>
                        )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
